import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppSettings } from '../config/app-settings';

@Injectable({
  providedIn: 'root'
})
export class CiudadService {

  recurso: string = '/ciudad';

  constructor(private http: HttpClient) { }

  listar(params:any): Observable<any> {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(function (key) {
      let param = params[key];
      if ('filters' === key) {
        param = JSON.stringify(params[key]);
      }
      httpParams = httpParams.append(key, param);
    });
    return this.http.get(AppSettings.API_URI_PUBLIC + this.recurso, {params: httpParams});
  }
}
